export default "__VITE_ASSET__jlWEDla0__"